import React from 'react';

export default {
  svg: (
    <g>
      <path
        d="M30,24.36V10.58h-1.15c-1.01,0-1.99,0.02-2.94,0.07V4.61l2.03-0.35L27.55,2L7.9,5.38v3.79H3.64v18.39H1.85v2.3
	h28.12v-2.3h-3.09v-3.2H30z M27.7,22.07H10.2V16.2v-0.22c2.02-0.77,8.41-2.93,17.51-3.1V22.07z M18.93,25.83v1.73h-1.37v-1.73h-1.84
	v1.73h-1.25v-3.2h7.61v3.2h-1.32v-1.73H18.93z M12.64,24.36v3.2h-1.12v-3.2H12.64z M23.62,5.01v5.78
	c-6.42,0.53-11.1,1.92-13.42,2.74V7.32L23.62,5.01z M5.94,11.47H7.9v3v1.73v8.16h1.78v3.2H5.94V11.47z M25.05,27.56h-1.12v-3.2h1.12
	V27.56z M18.76,19.04h-1.97v-2.3h1.97v-1.97h2.3v1.97h1.97v2.3h-1.97v1.97h-2.3V19.04z M19.35,9.71h-1.84V8.28h1.84V9.71z
	 M16.32,9.71h-1.84V8.28h1.84V9.71z M13.28,9.71h-1.84V8.28h1.84V9.71z M22.39,9.71h-1.84V8.28h1.84V9.71z"
      />
    </g>
  ),
  viewBox: '0 0 36 36'
};
